import React from 'react';
import { connect } from 'react-redux';
import { reloadPage } from '../../services/urlGeneratorService';
import FormDeviceToggle from './FormDeviceToggle';
import { ToggleContainer } from './DeviceToggleStyles';

class DeviceToggle extends React.Component {

  constructor(props) {
    super(props);
    this.state = {
      displayedDevice: this.props.app.deviceType
    }
    this.hasVersionToggle = this.props.app.shownMode;
    this.handleDeviceToggle = this.handleDeviceToggle.bind(this);
  }

  componentDidUpdate(prevProps) {
    if (prevProps.app.deviceType !== this.props.app.deviceType) {
      this.setState({ displayedDevice: this.props.app.deviceType });
    }
    if (prevProps.app.shownMode !== this.props.app.shownMode) {
      this.hasVersionToggle = this.props.app.shownMode;
    }
  }

  handleDeviceToggle(newMode) {
    this.setState({
      displayedDevice: newMode
    }, () => {
      const { provisions, ...rest } = this.props.app;
      setTimeout(reloadPage, 500, {
        ...rest,
        customParams: this.props.customParams,
        hostingElement: this.props.hostingElement,
        deviceType: newMode,
      })
    });
  }

  render() {
    if (!!!this.props.app.deviceType) {
      return null;
    }
    return (
      <ToggleContainer className={this.hasVersionToggle ? 'has-version-toggle' : ''}>
        <FormDeviceToggle
          deviceMode={this.state.displayedDevice}
          changeDevice={(mode) => this.handleDeviceToggle(mode)}
        />
      </ToggleContainer>
    )
  }
}

function mapStateToProps({ app, customParams, hostingElement }) {
  return {
    app,
    customParams,
    hostingElement
  }
}

export default connect(mapStateToProps, {})(DeviceToggle);